import React from 'react'
import { Card, Col, Row, Select, Slider, theme } from 'antd';
import { Area } from '@ant-design/plots';
import { ReloadOutlined } from '@ant-design/icons';
import TurnoverTenureChart from './SocialCharts/TurnoverTenureChart';
import Logo from '../../assets/image/logo/logo.png';
import Scatter from './SocialCharts/Scatter';
import GaugeComponent from './SocialCharts/Guage';
import Bar1 from './SocialCharts/Bar1';
import Bar2 from './SocialCharts/Bar2';
import Bar3 from './SocialCharts/Bar3';
import Lcharts from './SocialCharts/Lcharts';
import Bar4 from './SocialCharts/Bar4';
import Bar5 from './SocialCharts/Bar5';
import Bar6 from './SocialCharts/Bar6';


const { Option } = Select;

export default function Social() {
  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
      colorWarning,
      colorPrimaryBorder,
      colorTextDescription,
      colorText,
      colorBorder,
      fontSizeSM,
      colorErrorBgHover,
      colorPrimaryBgHover,
    },
    colorPrimary,
  } = theme.useToken();
  return (
    <>
      <Row gutter={16}>
        <Col span={6}>
          <Card bordered={false} style={{ height: 269 }} size='small'>
            <center>
            <img src={Logo}/>
            </center>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold', color: colorText }}>2016-12-15</span>
              <span style={{ fontWeight: 'bold', color: colorText }}>2024-12-15</span>
            </div>
            <Slider defaultValue={30} />

            {/* Date Filter */}
            <div style={{ marginTop: '16px' }}>
              <span style={{ fontWeight: 'bold', marginRight: '8px', color: colorText }}>Date</span>
              <Select defaultValue="All" style={{ width: '100%' }}>
                <Option value="all">All</Option>
                <Option value="today">Today</Option>
                <Option value="thisWeek">This Week</Option>
                <Option value="thisMonth">This Month</Option>
              </Select>
            </div>

            {/* Area Filter */}
            <div style={{ marginTop: '16px' }}>
              <span style={{ fontWeight: 'bold', marginRight: '8px', color: colorText }}>Area</span>
              <Select defaultValue="All" style={{ width: '100%' }}>
                <Option value="all">All</Option>
                <Option value="area1">Area 1</Option>
                <Option value="area2">Area 2</Option>
                <Option value="area3">Area 3</Option>
              </Select>
            </div>
          </Card>
          <br />
          <Card bordered={false} size="small" title="Veterans in the Workforce">
            <GaugeComponent value={10.2} min={0} max={100} size={200} />
          </Card>
          <br />
          <Card bordered={false} size="small" title="Women and Minorities in Management ">
            <GaugeComponent value={22.6} min={0} max={100} size={200} />
          </Card>
          <br />
          <Card bordered={false} size="small" title="Workforce Covered Under CBA ">
            <GaugeComponent value={13.8} min={0} max={100} size={200} />
          </Card>
          <br />
          <Card bordered={false} size="small" title="Workforce from Minorities Groups">
            <GaugeComponent value={17.1} min={0} max={100} size={200} />
          </Card>
        </Col>
        <Col span={18}>
          <Row gutter={16}>
            <Col span={10}>
              <Card bordered={false} style={{ maxHeight: 369 }} title="Days Away and Lost Time" size='small'>
<Scatter/>
              </Card>
            </Col>
            <Col span={8}>
              <Card bordered={false} style={{ maxHeight: 369 }} title="Safety Report " size='small'>
<Lcharts/>
              </Card>
            </Col>
            <Col span={6}>
              <Card bordered={false} style={{ maxHeight: 369 }} title="Preventable Motor Vehicle Accident" size='small'>
<Bar1/>
              </Card>
            </Col>
          </Row>
          <br/>
          <Row gutter={16}>
         
            <Col span={12}>
              <Card bordered={false} style={{ maxHeight: 269 }} title="Total Employees with % Under Collective Agreement" size='small'>
<Bar2/>
              </Card>
            </Col>
            <Col span={6}>
              <Card bordered={false} style={{ maxHeight: 269 }} title="" size='small'>
              <Bar3/>
              </Card>
            </Col>
            <Col span={6}>
              <Card bordered={false} style={{ maxHeight: 269 }} title="" size='small'>
<Bar4/>
              </Card>
            </Col>
          </Row>
<br/>
          <Row gutter={16}>
         
            <Col span={12}>
              <Card bordered={false} style={{ maxHeight: 369 }} title="Total Employees with Under Collective Agreement" size='small'>
<Bar5/>
              </Card>
            </Col>
            <Col span={12}>
              <Card bordered={false} style={{ maxHeight: 369 }} title="Total Community relations Giving US$" size='small'>
              <Bar6/>
              </Card>
            </Col>
            
          </Row>

        </Col>
      </Row>


    </>
  )
}
